import styled from 'styled-components';
import { BasketFeesDetailsStyled } from '../BasketFeesDetailsStyled';
import { rem } from 'polished';

export const BasketFeesDetailsAC = styled(BasketFeesDetailsStyled)`
    .title {
        font-size: ${rem(20)};
        color: ${({ theme }) => theme.colors.grey5};
    }
    .description {
        color: ${({ theme }) => theme.colors.grey5};
    }
    .malusFeesSummary,
    .carteGriseSummary {
        color: ${({ theme }) => theme.colors.grey5};
    }
    .carteGriseInput .postalCode {
        background: ${({ theme }) => theme.colors.grey5};
        border-radius: ${rem(12)};
        
        &_warning {
            .icon-wrapper {
                svg {
                    fill: ${({ theme }) => theme.colors.white};
                }
            }
        }
        &_input {
            input {
                border-radius: ${rem(12)};
            }
            button {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                border-radius: ${rem(24)};
                text-transform: capitalize;
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                border: 2px solid ${({ theme }) => theme.colors.white};
                &:hover {
                    background: none;
                    color: #9dc7e0;
                    border-color: #9dc7e0;
                }
            }
        }
      .titleWrapper {
        .isClose {
          svg {
            path {
              fill: ${({ theme }) => theme.colors.red};
            }
          }
        }
        .isOpen {
          svg {
            path {
              stroke: ${({ theme }) => theme.colors.red};
            }
          }
        }
      }
`;
